<template>
  <el-container class="login-wrap">
    <el-header class="home">
      <div class="homeUserNav">
        <div class="workListBox">
          <div>
            <a href="javascript:;">
              <img :src="logoSrc.default" class="logoImg" alt="logo" />
            </a>
            <!-- <span class="links marl20 cur" @click="officialhome">首页</span> -->
          </div>
          <div class="homeUserNavR">
            <span class="fz14 marr15">您好 {{ name }}</span>
            <el-dropdown size="medium" @command="handleCommand">
              <span class="el-dropdown-link">
                <i class="iconfont iconicon-topNavigation-setting fz18 changePassword"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <!-- <el-dropdown-item command="1">修改密码</el-dropdown-item> -->
                <el-dropdown-item command="2">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <!-- <i class="iconfont iconicon-topNavigation-close1 fz18 exit" @click="exit"></i> -->
          </div>
        </div>
      </div>
    </el-header>
    <el-main class="workListBg">
      <div class="workListcontent">
        <div class="title fz28 workListTitle">
          <div class="titleText">
            <div class="titleName">一脉阳光</div>
            医学影像质量控制平台
            <span class="loginversionNo">{{ versionNo }}</span>
          </div>
        </div>
        <div class="workListContentBox">
          <ul class="workList">
            <li
              class="latticeBg marb30"
              v-for="item in selectRole"
              :key="item.StationName"
              @click="workListBtn(item.RoleGuid)"
              v-preventReClick
            >
              <div class="iconBox">
                <svg class="icon" aria-hidden="true">
                  <use :xlink:href="`#${item.Icon}`"></use>
                </svg>
              </div>
              <div class="workListBtn">
                {{ item.StationName }}
              </div>
            </li>
          </ul>
        </div>
      </div>
    </el-main>
    <footers></footers>
  </el-container>
</template>

<script>
import { mapState } from "vuex";
import { cookieHandle } from "@/js/common";
import axios from "@/js/api";
import Footers from "@/components/Common/footers";
import { myMixin } from "@/assets/mixin.js";
export default {
  mixins: [myMixin],
  data() {
    return {
      callBackUrl: "",
      name: "",
      selectRoleClick: false,
      logincode: "",
      phone: "",
    };
  },
  components: {
    Footers,
  },
  computed: {
    ...Vuex.mapState("breadcrumb", ["versionNo"]),
    ...Vuex.mapState("login", ["dynamicValidateForm", "selectRole", "selectRoleList"]),
    ...Vuex.mapState("admin", ["rolesList", "listParameter"]),
  },
  created() {
    this.switchStatus();
    this.init();
  },
  activated() {
    this.init();
  },
  methods: {
    ...Vuex.mapMutations("login", ["setEnableRolesList"]),
    ...Vuex.mapActions("login", ["GetEnableRoles", "ChangeRole", "register", "ChangeRoles"]),
    ...Vuex.mapActions("admin", ["GetRoles"]),
    ...Vuex.mapActions("breadcrumb", ["GetBodyParts", "GetReportModality", "GetReportScanType"]),
    init() {
      // 判断登录状态
      let tokenCookie = null,
        loginUserCookieStr = null;
      tokenCookie = cookieHandle.getCookie(process.env.VUE_APP_BASE_TOKEN);
      loginUserCookieStr = cookieHandle.getCookie(process.env.VUE_APP_BASE_USERINFO);

      if (!loginUserCookieStr || !tokenCookie) {
        // const homeUrl = process.env.VUE_APP_HOME_URL;
        // const encodeUrl = encodeURIComponent(homeUrl);
        // const url = `${process.env.VUE_APP_LOGIN_URL}?callback_url=${encodeUrl}`;
        // location.href = url;
      } else {
        this.selectRoleClick = false;
        this.logincode = JSON.parse(decodeURIComponent(loginUserCookieStr)).logincode;
        this.phone = JSON.parse(decodeURIComponent(loginUserCookieStr)).phone;
        this.dynamicValidateForm.UserName = this.phone;
        // this.GetBodyParts();
        // this.GetReportModality()
        // this.GetReportScanType()
        if (this.getUriParam("UserName")) {
          this.phone = this.getUriParam("UserName");
          this.logincode = JSON.parse(decodeURIComponent(loginUserCookieStr)).logincode
            ? JSON.parse(decodeURIComponent(loginUserCookieStr)).logincode
            : this.phone;
          this.ChangeRoles({
            phone: this.phone,
            logincode: this.logincode,
            roleGuid: this.getUriParam("roleGuid"),
          });
        } else {
          this.GetEnableRoles().then((res) => {
            this.name = this.selectRoleList.Name;
            if (!this.selectRoleList.HasExisted) {
              this.register({
                phone: this.phone,
                logincode: this.logincode,
              });
            }
            if (this.selectRole.length == 1) {
              this.workListBtn(this.selectRole[0].RoleGuid);
            }
            if (this.selectRole.length == 0 || this.selectRole == null || this.selectRole == undefined) {
              this.listParameter.pageCount = 100;
              this.GetRoles({
                enable: "1",
              }).then((res) => {
                this.setEnableRolesList(this.rolesList);
                this.selectRoleClick = true;
              });
            }
          });
        }
      }
    },
    // 官网首页
    officialhome() {
      window.location.href = "https://www.rimagdata.com/";
    },
    handleCommand(command) {
      const basicUrl = process.env.VUE_APP_DOMAIN_HREF;
      const homeUrl = process.env.VUE_APP_HOME_URL;
      const encodeUrl = encodeURIComponent(homeUrl);
      let url = "";
      if (command == 1) {
        url = `${basicUrl}/editpassword?callback_url=${encodeUrl}`;
        location.href = url;
      } else {
        this.exit();
        // url = `${process.env.VUE_APP_LOGIN_URL}?callback_url=${encodeUrl}`;
      }
    },
    //退出
    exit() {
      let _this = this;
      // let loginUserCookieStr = cookieHandle.getCookie(process.env.VUE_APP_BASE_USERINFO),
      // 	data={},
      // 	logincodeval='';
      // const logincode = JSON.parse(decodeURIComponent(loginUserCookieStr)).logincode,
      // 	  phone = JSON.parse(decodeURIComponent(loginUserCookieStr)).phone;
      // if(logincode&&(logincode!=null||logincode!=''||logincode!=undefined)){
      // 	logincodeval = logincode;
      // }else{
      // 	logincodeval = phone;
      // }
      this.$confirm("确定要退出登录？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          _this.$router.push("/");
           axios.ssoOut('get', axios.Api.api.sso.loginOut)
           	.then(res => {
           		if (res.data.code == 200) {
           			let homeUrl = process.env.VUE_APP_HOME_URL;
           			const encodeUrl = encodeURIComponent(homeUrl);
           			const url = `${process.env.VUE_APP_LOGIN_URL}?callback_url=${encodeUrl}`;
           			localStorage.clear()
           			cookieHandle.clearCookie()
           			location.href = url;
           		}
           	});
        })
        .catch((err) => {
          this.$message({
            type: "info",
            message: "已取消退出登录",
          });
        });
    },
    workListBtn(RoleGuid) {
      if (this.selectRoleClick) {
        this.$alert(
          '<div class="tipsLogoImg"></div>非常抱歉!您尚未开通工作站权限<br/>请联系管理员,发送邮件至<br/>zouhaitao@rimag.com.cn',
          "申请权限",
          {
            customClass: "tipsImgClass",
            dangerouslyUseHTMLString: true,
            confirmButtonText: "确定",
            showClose: false,
            callback: (action) => {},
          }
        );
      } else {
        this.dynamicValidateForm.RoleId = RoleGuid;
        this.ChangeRole();
      }
    },
  },
};
</script>
<style>
.tipsImgClass .tipsLogoImg {
  width: 90px;
  height: 25px;
  background: url(../assets/images/dark/logo.png) no-repeat center;
  background-size: 100% 100%;
  position: absolute;
  top: -86px;
  left: 0;
  right: 0;
  margin: auto;
}
.tipsImgClass .el-message-box__message p {
  border-top: 1px solid #ff6e00;
  padding-top: 23px;
}
.tipsImgClass .el-message-box__title {
  padding-top: 30px;
}
.tipsImgClass .el-button--primary {
  width: 150px;
  height: 40px;
  background: #248afd;
  border-radius: 24px;
  font-size: 16px;
}
.tipsImgClass .el-message-box__title {
  font-size: 24px;
}
.tipsImgClass {
  width: 450px;
}
</style>
<style scoped="scoped">
.home .logo {
  border: none !important;
}
</style>
